import React, { useCallback, useContext, useEffect, useMemo, useState, useRef } from "react";
import { UserState } from "@/models/user";
import { connect } from "dvajs";
import { Avatar } from "@/baseComponents/Avatar";
import { getHeadImgThumbUrl } from "../../utils/chat/index";
import styles from "./SettingItem.module.less";
import IconFont from "@/components/icon";
import { useHistory } from "react-router-dom";
import Bus from "@/utils/bus";
import GlobalContext from "@/context/GlobalContext";
import { ThirdAppState } from "@/models/thirdapp";
import { sleep } from "@/utils/chat/message";
import SvgIcon from "@/baseComponents/SvgIcon";
import { appTrailApply } from "@/components/ThirdApp/utils";
import { notifyer } from "@/components/ThirdApp";
import { ThirdAppOpenType } from "@/types/common";
import { FocusSDK, isFocusEnv } from "@/utils";
import { isMebjJZB } from "@/utils/tools";

function SettingItem(props: any) {
  const { service, appRuntimeEnv } = useContext(GlobalContext);
  const {
    item,
    locked,
    notRemove,
    isEditing,
    navPopInfo,
    updateNavPopInfo,
    thirdAppMap,
    style
  } = props;
  const history = useHistory();
  // 删除
  const handleDelete = useCallback(
    (type: string, item: any) => {
      const pcSide = navPopInfo?.pcSide || {};
      if (!pcSide?.items) {
        pcSide.items = [];
      }
      pcSide.items = pcSide.items.filter((i: any) => i.name !== item.name);
      updateNavPopInfo({
        pcSide: { ...pcSide }
      });
    },
    [navPopInfo?.pcSide, updateNavPopInfo]
  );

  const handleGetApp = useCallback(
    async (appInfo: any) => {
      if (!service) {
        return false;
      }
      const { applicationId: appId, openType, homeUrl } = appInfo;
      const applicationInfo: any = thirdAppMap[appId];
      if (!isFocusEnv()) {
        window.open(homeUrl);
        return;
      }
      if (openType && openType === ThirdAppOpenType.WORKPLACE) {
        try {
          history.push("/third_apps");
          if (!appInfo) {
            return false;
          }
          await sleep(300);
          appTrailApply(
            appId,
            () => {
              Bus.emit("openThirdApp", appInfo);
            },
            notifyer,
            appInfo
          );
        } catch (e) {
          return false;
        }
      } else if (openType && openType === ThirdAppOpenType.INNER_FRAME) {
        history.push(`/linkContainer?url=${encodeURIComponent(homeUrl)}`);
        setTimeout(() => {
          Bus.emit("linkContainer:linkUrl", {
            url: homeUrl,
            appInfo: applicationInfo
          });
        });
      } else if (openType && openType === ThirdAppOpenType.INNER_BROWSER) {
        window.open(homeUrl);
        return;
      } else {
        FocusSDK.openUrl(homeUrl);
        return;
      }
      return true;
    },
    [history, service, thirdAppMap]
  );

  // 处理点击
  const handleItemClick = useCallback(
    (item) => {
      if (item?.type === "add") {
        updateNavPopInfo({
          appModalShow: true
        });
        return;
      }
      if (isEditing) {
        return;
      }
      // 路由
      if (item?.role === "loadUrl") {
        // 237 内置应用
        if (!isFocusEnv()) {
          window.open(item?.pcUrl);
          return;
        }
        history.push(`${item?.path}?url=${encodeURIComponent(item?.pcUrl)}`);
        setTimeout(() => {
          Bus.emit("linkContainer:linkUrl", {
            url: item?.pcUrl
          });
        });
        return;
      }
      if (item?.path) {
        history.push(item?.path);
        Bus.emit("onNavItemClick", item?.path);
        return;
      }
      // 三方应用
      // 237 - 导航场景
      if (item?.applicationId) {
        handleGetApp(item);
        return;
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [history, updateNavPopInfo, handleGetApp]
  );

  const cnName = useMemo(() => {
    return item.cnName || appRuntimeEnv?.getI18N(item.name);
  }, [appRuntimeEnv, item?.cnName, item?.name]);

  const tipComp = useMemo(() => {
    return !isEditing && item?.tip ? (
      <div className={styles["dot"]}>
        {Number(item?.tip) > 99
          ? `${isMebjJZB() ? <IconFont type="iconapp_btn_joymerting_more" /> : "99+"}`
          : item?.tip}
      </div>
    ) : null;
  }, [isEditing, item?.tip]);
  return (
    <div
      className={`${styles["setting-item"]} ${styles["item"]}`}
      style={style}
      key={item.name}
      onClick={() => handleItemClick(item)}
    >
      {tipComp}
      <div className={styles["item-content"]}>
        {item.svg ? (
          <SvgIcon url={item.svg} style={{ width: "24px", height: "24px" }} />
        ) : item.avatar ? (
          <Avatar
            name={cnName}
            avatarMask={false}
            styleObj={{height: 24, width: 24, fontSize: "12px"}}
            src={getHeadImgThumbUrl(item.avatar, 24, 24)}
            className={styles["icon"]}
          />
        ) : (
          <IconFont
            type={item.name === "layout.nav.homePage" ? "iconshouye" : item.icon}
            className={styles["icon"]}
          />
        )}
        <span className={`${styles["name"]} ellipsis`}>{cnName}</span>
      </div>
      {isEditing && !locked && !notRemove ? (
        <IconFont
          type="iconpc_ic_quxsc_doc"
          className={styles["del"]}
          onClick={() => handleDelete("main", item)}
        />
      ) : null}
    </div>
  );
}
function mapStateToProps({ user, thirdapp }: { user: UserState; thirdapp: ThirdAppState }) {
  return {
    navPopInfo: user.navPopInfo,
    teamConfig: user.teamConfig,
    thirdAppMap: thirdapp.thirdAppMap
  };
}

function mapDispatchToProps(dispatch: any) {
  return {
    updateNavPopInfo(payload: any) {
      dispatch({ type: "user/updateNavPopInfo", payload });
    },
    updateTeamConfig(payload: any) {
      dispatch({ type: "user/updateTeamConfig", payload });
    }
  };
}
export default connect(mapStateToProps, mapDispatchToProps)(SettingItem);
